// client/src/components/ScrollToTop.tsx
"use client";

import { useEffect } from 'react';
import { usePathname } from 'next/navigation'; // Use usePathname from next/navigation

export default function ScrollToTop() {
 const pathname = usePathname();

 useEffect(() => {
 // Scroll to top when path changes
 window.scrollTo(0, 0);
 }, [pathname]);

 return null;
}
